module.exports = __webpack_public_path__ + "8e84ffa0c0b03ff133255bba008a9c57.pdf";